import React from 'react';

function LoadingPageType() {
  return <main />;
}

export default LoadingPageType;
